export default "__VITE_ASSET__3y678CVZ__"